import { render, staticRenderFns } from "./SeckillView.vue?vue&type=template&id=3ba01d42"
import script from "./SeckillView.vue?vue&type=script&lang=js"
export * from "./SeckillView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports